import { TrendingUp, Building2 } from "lucide-react";

// "Top Referring General Practice Clinics This Month" — driven by Select for Referral events.
export const TopReferrers = ({ rows = [], testId = "top-referrers" }) => {
  const max = rows.length ? rows[0].count : 0;
  const monthLabel = new Date().toLocaleDateString("en-AU", { month: "long", year: "numeric" });

  return (
    <section data-testid={testId}>
      <div className="flex items-center gap-2">
        <TrendingUp className="h-5 w-5 text-primary" />
        <h2 className="font-heading text-lg font-semibold text-slate-900">Top referring GP clinics</h2>
      </div>
      <p className="mt-1 text-sm text-slate-500">{monthLabel} · counted from Select for Referral activity. No patient information.</p>

      {rows.length === 0 ? (
        <div className="mt-4 rounded-md border border-dashed border-slate-300 bg-white p-8 text-center" data-testid={`${testId}-empty`}>
          <Building2 className="mx-auto h-7 w-7 text-slate-300" />
          <p className="mt-2 text-sm text-slate-500">No GP practice selections this month yet.</p>
        </div>
      ) : (
        <div className="mt-4 space-y-3 rounded-md border border-slate-200 bg-white p-5">
          {rows.map((r) => (
            <div key={r.name} className="flex items-center gap-3" data-testid={`${testId}-row`}>
              <div className="w-40 shrink-0 truncate text-sm font-medium text-slate-700" title={r.name}>{r.name}</div>
              <div className="relative h-6 flex-1 overflow-hidden rounded-md bg-slate-100">
                <div
                  className="absolute inset-y-0 left-0 rounded-md bg-primary/80"
                  style={{ width: `${max ? Math.max(8, (r.count / max) * 100) : 0}%` }}
                />
              </div>
              <div className="w-8 shrink-0 text-right text-sm font-semibold text-slate-900">{r.count}</div>
            </div>
          ))}
        </div>
      )}
    </section>
  );
};
